<div class="tile__status tile__status--default" data-testid="tile">
    <div class="tile__svg--other-wrapper">
        <img class="tile__svg--other"
             ngSrc="/assets/img/icons/opentherm-red.svg"
             width="50" height="50" alt=""/>
    </div>
    <floating-subtitle class="tile__subtitle"
                       [text]="subtitle(3645)">
    </floating-subtitle>
    <div class="tile__value tile__value-no-left-margin">
        <div class="tile__value-wrapper">
            <p class="tile__value-label font-18 color-default"
               data-testid="text-value">
                {{ subtitle(127) }}
            </p>
            <p class="tile__value-current font-24 font-bold color-style"
               data-testid="current-temp"
               *ngIf="subtitles.downloaded">
                {{ tile.params.currentTemp | format:7 }}
            </p>
            <p class="tile__value-set-temp font-18 color-default"
               data-testid="set-temp"
               *ngIf="subtitles.downloaded">
                {{ tile.params.setCurrentTemp | format:7 }}
            </p>
        </div>
        <div class="tile__value-wrapper">
            <p class="tile__value-label font-18 color-default"
                data-testid="text-value-dhw">
                {{ subtitle(128) }}
            </p>
            <p class="tile__value-current font-24 font-bold color-style"
               data-testid="current-temp-dhw"
               *ngIf="subtitles.downloaded">
                {{ tile.params.currentTempDHW | format:7 }}
            </p>
            <p class="tile__value-set-temp font-18 color-default"
               data-testid="set-temp-dhw">
                {{ tile.params.setTempDHW | format:7 }}
            </p>
        </div>
    </div>
    <div class="tile__setting cursor-pointer"
         [ngClass]="{ 'bg-light-shadow': tile.elementMenu.duringChange === 't' }"
         *ngIf="tile.elementMenu && tile.menuId !== 0"
         (click)="openSubmenu()">
        <img ngSrc="/assets/img/icons/{{ getIconName() }}.svg"
             width="30" height="30" alt=""/>
        <p class="tile__setting-alert font-12 color-light"
           *ngIf="tile.elementMenu.duringChange === 't'">
            {{ subtitle(3162) }}
        </p>
    </div>
    <div class="hover-area cursor-pointer" data-testid="hover-area"
         (click)="openSubmenu()">
    </div>
    <div class="hover bg-dark-shadow box-shadow" data-testid="parameters">
        <div class="hover__item color-light font-12"
             *ngIf="tile.params.modulationPercentage >=0 && tile.params.modulationPercentage <= 100">
            <p class="hover__name">{{ subtitle(428) }}</p>
            <p class="hover__value">
                {{ tile.params.modulationPercentage | format:8 }}
            </p>
        </div>
        <div class="hover__item color-light font-12"
             *ngIf="tile.params.flags.communication === 0">
            <p class="hover__name">{{ subtitle(331) }}</p>
            <p class="hover__value">{{ subtitle(637) }}</p>
        </div>
        <div class="hover__item color-light font-12">
            <p class="hover__name">{{ subtitle(342) }}</p>
            <p class="hover__value">
                {{ tile.params.flags.heatingCurve | format:28 }}
            </p>
        </div>
        <div class="hover__item color-light font-12">
            <p class="hover__name">{{ subtitle(2585) }}</p>
            <p class="hover__value">
                {{ tile.params.flags.activeHeating | format:28 }}
            </p>
        </div>
        <div class="hover__item color-light font-12">
            <p class="hover__name">{{ subtitle(2586) }}</p>
            <p class="hover__value">
                {{ tile.params.flags.activeDHW | format:28 }}
            </p>
        </div>
    </div>
</div>
